<div class="section" *ngIf="hasTrainingData || editModeSet">
  <div class="section__header">
    <h2 class="section__header-text">Flight Training</h2>
  </div>
  <div class="section__body">
    <div class="data-block data-block--shaded-labels">
      <div *ngIf="isSectionVisible([classificationTags])" class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isRegionalManager">FAA Classification:
          <mat-icon (click)="openEditTrainingDialog(['Flight Training::Classification::'], null, 'FAA Classifications')"
            *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="classificationTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !classificationTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Approved for VA Training:
          <mat-radio-group *ngIf="editModeSet && !isRegionalManager" class="vaTraining-radio-group">
            <div class="va-training-radio-container">
              <mat-radio-button class="training-radio-btn" value="1" [checked]="isApprovedForVaTraining" (change)="approvedForVaTrainingChange($event)">Yes</mat-radio-button>
              &nbsp;
              <mat-radio-button class="training-radio-btn" value="2" [checked]="!isApprovedForVaTraining" (change)="approvedForVaTrainingChange($event)">No</mat-radio-button>
            </div>
          </mat-radio-group>
        </div>
        <div class="data-block__value">
          {{ isApprovedForVaTraining | boolean : 'No'}}
        </div>
      </div>
      <div class="data-block__item">
        <div *ngIf="business.collegeName || editModeSet" class="data-block__item">
          <div class="data-block__label">Affiliated College/University:
          </div>
          <div class="data-block__value">
            <div *ngIf="!editModeSet || isRegionalManager">{{ business.collegeName }}</div>
            <div *ngIf="editModeSet && !isRegionalManager" class="college-name--input">
              <mat-form-field>
                <input matInput type="text" placeholder="College/University Name:" [(ngModel)]="collegeName">
              </mat-form-field>
              <button mat-icon-button id="saveCollegeNameBtn" (click)="updateCollegeName(collegeName)">
                <mat-icon>save</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isSectionVisible([servicesTags])" class="data-block__item">
        <div class="data-block__label">Services:
          <mat-icon (click)="openEditTrainingDialog(['Flight Training::Services::'], null, 'Services')" *ngIf="editModeSet && !isRegionalManager"
            class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="servicesTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !servicesTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>

      <!-- HIDING RATIONALE
        As per request this is being hidden at the moment, they mAY eventually want to bring this back so we can just uncomment it out to bring it back

        <div class="data-block__item">
        <div class="data-block__label">Certified Flight Instructors:
        </div>
        <div class="data-block__value">
          <ul class="ul--three-col">
            <li>
              <div *ngIf="cfi_FullTime || cfi_FullTime === 0">Full Time: {{cfi_FullTime}}</div>
              <div *ngIf="!cfi_FullTime && cfi_FullTime !== 0">Full Time: Unknown</div>
              <mat-form-field class="cfi--input" *ngIf="editModeSet">
                <input matInput type="number" min="0" max="200" placeholder="Full Time:" [formControl]="fullTimeInstructorRangeControl"
                  [(ngModel)]="cfi_FullTime">
                <mat-error>Please enter a value between 0 and 200</mat-error>
              </mat-form-field>
            </li>
            <li>
              <div *ngIf="cfi_PartTime || cfi_PartTime === 0">Part Time: {{cfi_PartTime}}</div>
              <div *ngIf="!cfi_PartTime && cfi_PartTime !== 0">Part Time: Unknown</div>
              <mat-form-field class="cfi--input" *ngIf="editModeSet">
                <input matInput type="number" min="0" max="200" placeholder="Part Time:" [formControl]="partTimeInstructorRangeControl"
                  [(ngModel)]="cfi_PartTime">
                <mat-error>Please enter a value between 0 and 200</mat-error>
              </mat-form-field>
            </li>
            <li>
              <div *ngIf="cfi_Contracted || cfi_Contracted === 0">Contracted: {{cfi_Contracted}}</div>
              <div *ngIf="!cfi_Contracted && cfi_Contracted !== 0">Contracted: Unknown</div>
              <mat-form-field class="cfi--input" *ngIf="editModeSet">
                <input matInput type="number" min="0" max="200" placeholder="Contracted:" [formControl]="contractInstructorRangeControl"
                  [(ngModel)]="cfi_Contracted">
                <mat-error>Please enter a value between 0 and 200</mat-error>
              </mat-form-field>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
  </div>
  <div *ngIf="editModeSet && !isRegionalManager; else notEditing" class="section__footer">
    <mat-checkbox #checkbox [checked]="isPrivate" class="footer__checkbox" [(ngModel)]="isPrivate" (change)="isPrivateChange($event)">Flight
      training not available to the general public.</mat-checkbox>
  </div>
</div>
<ng-template #notEditing>
  <div class="section__footer" *ngIf="isPrivate">
    <div class="training__disclaimers">
      <em>Flight training not available to the general public.</em>
    </div>
  </div>
</ng-template>
<div class="section" *ngIf="hasTrainingOpportunitiesData || editModeSet">
  <div class="section__header">
    <h2 class="section__header-text">Training Opportunities</h2>
  </div>
  <div class="section__body">
    <div class="data-block data-block--shaded-labels">
      <div *ngIf="isSectionVisible([certificationTags])" class="data-block__item">
        <div class="data-block__label">Certifications:
          <mat-icon (click)="openEditTrainingDialog(['Flight Training::Certification::'], null, 'Certifications')"
            *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="certificationTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !certificationTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="isSectionVisible([ratingTags])" class="data-block__item">
        <div class="data-block__label">Ratings:
          <mat-icon (click)="openEditTrainingDialog(['Flight Training::Rating::'], null, 'Ratings')" *ngIf="editModeSet && !isRegionalManager"
            class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="ratingTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !ratingTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="isSectionVisible([advancedTrainingTags])" class="data-block__item">
        <div class="data-block__label">Other Advanced Training:
          <mat-icon (click)="openEditTrainingDialog(['Flight Training::Advanced::'], null, 'Advanced Flight Training')"
            *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="advancedTrainingTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !advancedTrainingTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
